import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/services/apiClient'
import type { Capability } from '@/types/toolFramework'

export function useCapabilities(opts?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['capabilities'],
    queryFn: () => apiClient.get<Capability[]>('/api/capabilities'),
    // The capabilities router only registers under tool_framework —
    // callers on deployments without it pass enabled:false so we never
    // fire a guaranteed-404 request.
    enabled: opts?.enabled ?? true,
  })
}

export function useCapability(id: string) {
  return useQuery({
    queryKey: ['capability', id],
    queryFn: () => apiClient.get<Capability>(`/api/capabilities/${id}`),
    enabled: id !== '',
  })
}
